export const STORAGE_AUTH_KEY = "cologuardAuth";
export const STORAGE_USER_KEY = "cologuardUser";
export const STORAGE_LAUNCH_KEY = "cologuardLatestLaunch";

export const DESIGNATOR_ALPHABET = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
export const MIN_CAMPAIGN_DESIGNATOR_LENGTH = 3;
export const MAX_CAMPAIGN_DESIGNATOR_LENGTH = 8;
export const SUGGESTED_CAMPAIGN_DESIGNATOR_LENGTH = 6;

export const ACCESS_MODE_SIGN_IN = "sign-in";
export const ACCESS_MODE_REGISTER = "register";

export const INITIAL_CAMPAIGN_FORM = {
  campaignPrefix: "",
  campaignName: "",
  fromDate: new Date().toISOString().slice(0, 10),
  toDate: "",
  requestedCodeQuantity: 500,
};

export const COUPON_GENERATION_BATCH_SIZE = Math.max(
  1,
  Number(process.env.REACT_APP_COLOGUARD_GENERATION_BATCH_SIZE) || 250
);
export const MAX_CAMPAIGN_CODE_QUANTITY = Math.max(
  1,
  Number(process.env.REACT_APP_COLOGUARD_MAX_CAMPAIGN_QUANTITY) || 100000
);
export const SUMMARY_CAMPAIGN_LIMIT = 10;

export const COLOGUARD_ROLES = Object.freeze({
  ADMIN: "admin",
  MANAGER: "manager",
  VIEWER: "viewer",
});

export const SECTION_NAV = [
  {
    key: "summary",
    label: "Summary",
    path: "/cologuard",
    roles: [COLOGUARD_ROLES.ADMIN, COLOGUARD_ROLES.MANAGER, COLOGUARD_ROLES.VIEWER],
  },
  {
    key: "setup",
    label: "Campaign Setup",
    path: "/cologuard/setup",
    roles: [COLOGUARD_ROLES.ADMIN, COLOGUARD_ROLES.MANAGER],
  },
  {
    key: "history",
    label: "History",
    path: "/cologuard/history",
    roles: [COLOGUARD_ROLES.ADMIN, COLOGUARD_ROLES.MANAGER, COLOGUARD_ROLES.VIEWER],
  },
  {
    key: "users",
    label: "User Management",
    path: "/cologuard/users",
    roles: [COLOGUARD_ROLES.ADMIN],
  },
  {
    key: "instructions",
    label: "Instructions",
    path: "/cologuard/instructions",
    roles: [COLOGUARD_ROLES.ADMIN, COLOGUARD_ROLES.MANAGER, COLOGUARD_ROLES.VIEWER],
  },
];

export function roleCanAccessSection(role, sectionKey) {
  const section = SECTION_NAV.find(({ key }) => key === sectionKey);
  return Boolean(section?.roles.includes(String(role || "").toLowerCase()));
}

export const HISTORY_STATUS_OPTIONS = [
  "All",
  "Requested",
  "Released",
  "Order Attached",
  "Available",
];

export const CAMPAIGN_HISTORY_STATUS_OPTIONS = [
  { value: "", label: "All statuses" },
  { value: "draft", label: "Not started" },
  { value: "generation_requested", label: "Starting" },
  { value: "coupon_generation_queued", label: "Scheduled" },
  { value: "generation_in_process", label: "Preparing codes" },
  { value: "generation_complete", label: "Codes ready" },
  { value: "active", label: "Active" },
  { value: "generation_error", label: "Needs review" },
];

export const INITIAL_USER_FORM = {
  name: "",
  email: "",
  role: "viewer",
};
